/**
 * UI chrome click handlers — open-lang, toggle-mobile-menu, cookie banner.
 *
 * Originally inline in `main.ts` lines 112-116, 269-276. Phase 2.3 split.
 */
import { openLangPicker } from '../modals';
import { haptic as tgHaptic } from '../telegram-mini-app';

export function openLangAction(e: MouseEvent): void {
  e.preventDefault();
  tgHaptic.tapLight();
  openLangPicker();
}

export function toggleMobileMenuAction(): void {
  tgHaptic.tapLight();
  document.getElementById('mobile-menu')?.classList.toggle('is-open');
}

/**
 * Cookie banner: 'cookie-essential' or 'cookie-all'. Stores the choice
 * in localStorage under `roamzy_cookie` and hides the banner.
 */
export function cookieChoiceAction(_e: MouseEvent, target: HTMLElement): void {
  const action = target.dataset.action;
  if (action !== 'cookie-essential' && action !== 'cookie-all') return;
  localStorage.setItem('roamzy_cookie', action.replace('cookie-', ''));
  document.getElementById('cookie-banner')?.setAttribute('hidden', '');
}
